import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = no auth
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    setUser(null);
    window.location.href = "/login";
  };

  const impersonate = async (userId) => {
    await api.post(`/auth/impersonate/${userId}`);
    window.location.href = "/dashboard";
  };

  const stopImpersonation = async () => {
    await api.post("/auth/stop-impersonation");
    window.location.href = "/tenants";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout, impersonate, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
